import { useEffect, useRef } from "react";
import useLogout from "./useLogout";
import { useAppSelector } from "../../store";

export interface useAutoLogoutProps {
    timeout: number
}


export default function useAutoLogout(props: useAutoLogoutProps) {
    const {timeout} = props
    const timer = useRef<NodeJS.Timeout>(null)
    const {logout, isLoading, error, errors} = useLogout()
    const user = useAppSelector(state => state.user.user)
    const resetTimer = () => {
        if(timer.current) clearTimeout(timer.current)
        timer.current = setTimeout(logout, timeout)
    }

    useEffect(() => {
        if(!user) {
            return;
        }
        const events = ["mousemove", "keydown", "click", "scroll", "touchstart"]
        events.forEach(event => window.addEventListener(event, resetTimer))
        resetTimer()
        return () => {
            events.forEach(event => window.removeEventListener(event, resetTimer))
            if(timer.current) clearTimeout(timer.current)
        }
    }, [user])
    return [isLoading, error, errors];
}